export default __webpack_public_path__ + "static/media/ic_malawi.5074afae.svg";